import { Typography } from "@mui/material"

interface SectionTitleProps {
  title: string,
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title }) => {
  return (<>
    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1976d2', fontStyle: 'italic' }}>{title}</Typography>
  </>)
}

export default SectionTitle
